<template>
  <nav>
    <ul class="menu">
      <li class="hello">
        <router-link
              active-class="is-active"
              class="link"
              :to="{ name: 'HelloWorld' }">
          <span class="title">Home</span>
        </router-link>
      </li>
      <li class="about">
        <router-link
              active-class="is-active"
              class="link"
              :to="{ name: 'About' }">
          <span class="title">About</span>
        </router-link>
      </li>
      <li class="customer">
        <router-link
              active-class="is-active"
              class="link module"
              :to="{ name: 'CustomerAttributes' }">
          <span class="title">Customer Attributes</span>
        </router-link>
      </li>
      <li class="cms-transfer">
        <router-link
              active-class="is-active"
              class="link module"
              :to="{ name: 'CmsTransfer' }">
          <span class="title">CmsTransfer</span>
        </router-link>
      </li>
      <li class="elastic">
        <router-link
              active-class="is-active"
              class="link module"
              :to="{ name: 'ElasticStatus' }">
          <span class="title">Elastic Status</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Menu'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
nav {
  display: block;
  @media screen and (max-width: 720px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue